export default __webpack_public_path__ + "static/Baby-on-plan-with-family-64188027bb215b62d61de429d28ba99f.jpg";